export const TEMPLATE_CATEGORIES = {
  ai: 'AI',
  analytics: 'Analytics',
  automation: 'Automation',
  baas: 'BaaS',
  cms: 'CMS',
  demo: 'Demo',
  storage: 'Storage',
}
